import Product from '@src/quince-site-common/src/domains/Product'
import { ContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder'

export enum ProductSectionType {
  PRODUCT_IMAGES = 'PRODUCT_IMAGES',
  PRODUCT_PURCHASE = 'PRODUCT_PURCHASE',
  PRODUCT_DETAILS_AND_CARE = 'PRODUCT_DETAILS_AND_CARE',
  BRAND_COMPARISON = 'BRAND_COMPARISON',
  PAIR_WITH = 'PAIR_WITH',
  FREQUENTLY_BOUGHT_TOGETHER = 'FREQUENTLY_BOUGHT_TOGETHER',
  SIMILAR_PRODUCTS = 'SIMILAR_PRODUCTS',
  TRANSPARENT_PRICING = 'TRANSPARENT_PRICING',
  PRODUCT_REVIEWS = 'PRODUCT_REVIEWS',
  YOU_MAY_ALSO_LIKE = 'YOU_MAY_ALSO_LIKE',
  REVIEW_HIGHLIGHTS = 'REVIEW_HIGHLIGHTS',
  CUSTOM_SECTION = 'CUSTOM_SECTION',
  BUNDLE_PRODUCT_IMAGES_AND_PURCHASE = 'BUNDLE_PRODUCT_IMAGES_AND_PURCHASE',
  MINI_SIMILAR_PRODUCTS = 'MINI_SIMILAR_PRODUCTS',
  DISCLAIMER = 'DISCLAIMER',
  B2B_SIMILAR_PRODUCTS = 'B2B_SIMILAR_PRODUCTS',
  B2B_FREQUENTLY_BOUGHT_TOGETHER = 'B2B_FREQUENTLY_BOUGHT_TOGETHER',
}

export interface ProductPageSectionProps {
  product: Product
  mobileContainerConfig?: ContainerConfig
}
